import { Zap } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "./ui/tooltip";

/**
 * BoostedBadge — transparency disclosure displayed on Marketplace listings
 * that have a paid boost active. Tooltip explains how the placement works
 * and shows the remaining time + provider name.
 */
export default function BoostedBadge({ providerName, expiresAt, testId }) {
  const remaining = formatRemaining(expiresAt);
  return (
    <TooltipProvider delayDuration={150}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            className="inline-flex items-center gap-1 text-[10px] uppercase tracking-[0.18em] px-2 py-0.5 rounded-sm bg-secondary/15 text-secondary border border-secondary/30 cursor-help"
            data-testid={testId}
          >
            <Zap size={9} strokeWidth={2.5} /> Boosted
          </span>
        </TooltipTrigger>
        <TooltipContent
          className="max-w-[260px] bg-card text-card-foreground border-secondary/30 p-3 text-xs leading-relaxed space-y-1.5"
          side="top"
        >
          <div className="font-medium text-secondary uppercase tracking-wider text-[10px]">
            Boosted listing
          </div>
          <div>
            {providerName ? <>Boosted by <span className="text-foreground">{providerName}</span></> : "Boosted placement"}
            {remaining && <> · {remaining}</>}
          </div>
          <div className="text-foreground/55 text-[11px] pt-1 border-t border-foreground/10">
            Same trust scores, verification, and reviews apply. Boost only changes placement order — not credibility.
          </div>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}

function formatRemaining(iso) {
  if (!iso) return null;
  const ms = new Date(iso).getTime() - Date.now();
  if (ms <= 0) return "expired";
  const hours = ms / (1000 * 60 * 60);
  if (hours < 1) return `${Math.max(1, Math.round(ms / (1000 * 60)))}m left`;
  if (hours < 24) return `${Math.round(hours)}h left`;
  return `${Math.round(hours / 24)}d left`;
}
